exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".quote{width:100%}.quote blockquote{color:#fff;font-size:1.875em;line-height:1.333333333333333em;font-family:Poppins,sans-serif;letter-spacing:.01em}@media screen and (max-width:640px){.quote blockquote{font-size:1.5em}}.quote .translation{color:#fff;font-size:.9375em;line-height:1.4em;letter-spacing:.15em;font-family:Saira Extra Condensed,sans-serif;font-weight:300;text-transform:uppercase;margin-top:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f1a1f97","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content-elements/quote.vue
// module id = 472
// module chunks = 0